import { locale } from '../services/translator';
import { webServiceHost, webServiceMobileHost } from '../services/dior';

export const NAV_POPIN_DELAY = 500;
export const NAV_UNIVERSE_COOKIE = 'currentUniverse';
export const NAV_AVAILABLE_IDENTIFIERS = {
  'womens-fashion': 'cdc',
  'mens-fashion': 'cdc',
  'FRAGRANCE': 'pcd',
  'MAKEUP': 'pcd',
  'SKINCARE': 'pcd',
  'childrens-fashion': 'cdc',
  'jewellery': 'cdc',
  'timepieces': 'cdc'
};

export const NAV_MOBILE_URLS = {
  development: `/fixtures/navmobile.json`,
  test: `/fixtures/navmobile.json`,
  preProduction: `${webServiceMobileHost}/${locale}/static/menu/64,pcd,66.json`,
  production: `${webServiceMobileHost}/${locale}/static/menu/64,pcd,66.json`
};

export const NAV_MOBILE_LINKS_URLS = {
  development: `/fixtures/navmobile_bottom.json`,
  test: `/fixtures/navmobile_bottom.json`,
  preProduction: `${webServiceMobileHost}/${locale}/static/menu/main.json`,
  production: `${webServiceMobileHost}/${locale}/static/menu/main.json`
};

export const NAV_METANAV_URLS = {
  development: `/fixtures/metanav.json`,
  test: `/fixtures/metanav.json`,
  preProduction: `${webServiceHost}/couture/${locale}/ws/metanav`,
  production: `${webServiceHost}/couture/${locale}/ws/metanav`
};

export const NAV_SUBNAV_URLS = {
  development: (universe) => `/fixtures/${universe}.json`,
  test: (universe) => `/fixtures/${universe}.json`,
  preProduction: (universe) => `${webServiceHost}/couture/${locale}/ws/topmenu/v2/${universe}`,
  production: (universe) => `${webServiceHost}/couture/${locale}/ws/topmenu/v2/${universe}`
};

export const NAV_FOOTER_URLS = {
  development: `/fixtures/footer.json`,
  test: `/fixtures/footer.json`,
  preProduction: `${webServiceHost}/couture/${locale}/ws/footer`,
  production: `${webServiceHost}/couture/${locale}/ws/footer`
};

export const NAV_FOOTER_MOBILE_URLS = {
  development: `/fixtures/footer_mobile.json`,
  test: `/fixtures/footer_mobile.json`,
  preProduction: `${webServiceMobileHost}/couture/${locale}/dior/footer_v2`,
  production : `${webServiceMobileHost}/couture/${locale}/dior/footer_v2`
};



// WEBPACK FOOTER //
// ./src/settings/nav.js